import { FC } from "react";

import { RouteBlockMapLibre } from "./route-block-maplibre";
import { IRouteBlockProps } from "./route-block.models";

/** The ride map. */
export const RouteBlock: FC<IRouteBlockProps> = props => (
  <RouteBlockMapLibre {...props} />
);
